

















































import { computed, defineComponent, getCurrentInstance, ref, toRefs, watch } from '@vue/composition-api';
import FileInfo from '@/renderer/components/drawer/Detail/FileInfo.vue';
import FileMemberManage from '@/renderer/components/drawer/MemberManage/FileMemberManage.vue';
import History from '@/renderer/components/drawer/History/index.vue';
import { formatSize, formatType, getFilePath } from '@/renderer/scripts/utils/tools/index';
import ipc from '@/renderer/scripts/utils/ipc';
import { SMH } from '@/renderer/scripts/smh';
function formatSizeString(itemSize?: string) {
  const { size, unit } = formatSize(itemSize as string);
  return `${size} ${unit}`;
}
export default defineComponent({
  components: {
    FileInfo,
    FileMemberManage,
    History,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = ref(false);
    const tabValue = ref('detail');

    // eslint-disable-next-line max-len
    const drawers = computed<Drawer.Scope<SMH.SpaceFileItemData | SMH.ColleborationSpaceInfoData>[]>(
      () => vm.$store.state.drawer.drawers,
    );
    const drawerParam = computed<{
      spaceId: string;
      selectedItem: unknown;
    }>(() => {
      let params = {
        spaceId: '',
        selectedItem: {},
      };
      if (drawers.value.length > 0 && drawers.value[0].params) {
        const drawer = drawers.value[0];
        if (drawer.params) {
          params = drawer.params as Drawer.BaseParams<SMH.SpaceFileItemData | SMH.ColleborationSpaceInfoData>;
        }
      }
      return params;
    });
    const selectItem = computed(() => drawerParam.value?.selectedItem);
    const spaceId = computed(() => vm.$route.query?.spaceId || drawerParam.value?.spaceId);
    const showOptions = computed(() => {
      const show: Record<string, boolean> = {
        detail: false,
        history: false,
        fileMemberManage: false,
      };
      drawers.value.forEach(item => {
        const key = item.componentName.slice(0, 1).toLowerCase() + item.componentName.slice(1);
        if (key in show) {
          show[key] = true;
        }
      });
      return show;
    });
    const methods = {
      onReturn() {
        innerShow.value = false;
      },
    };
    ipc.on(ipc.RENDERER_EVENTS_MAP.COMMAND_SHOW_DETAIL, (type: string, showVal?: boolean) => {
      tabValue.value = type;
      innerShow.value = typeof showVal !== 'undefined' ? showVal : true;
    });
    watch(
      () => [vm.$route.name, vm.$route.query],
      (newVal: any[], oldVal: any[]) => {
        const [routeName, routeQuery] = newVal;
        const [oldRouteName, oldRouteQuery] = oldVal;
        if (routeName !== oldRouteName) {
          methods.onReturn();
        } else if (routeName === 'teamSpace' && routeQuery.spaceId !== oldRouteQuery.spaceId) {
          methods.onReturn();
        }
      },
    );
    return {
      innerShow,
      tabValue,
      showOptions,
      spaceId,
      selectItem,
      ...methods,
    };
  },
});
